import { EFiltersActions } from '../../../constants/actionTypes/filters';
import { TReduxActions } from '../../../types/redux';
import { IFiltersState } from '../../../types/redux/filters';

export function realtorsFiltersReducer(state: IFiltersState = {}, action: TReduxActions) {
  switch (action.type) {
    case EFiltersActions.SET_DEAL_TYPE_REALTORS:
      return {
        ...state,
        dealType: action.payload,
      };

    case EFiltersActions.SET_OFFER_TYPE_REALTORS:
      return {
        ...state,
        offerType: action.payload,
      };

    case EFiltersActions.SET_SORT_BY_REALTORS:
      return {
        ...state,
        sortBy: action.payload,
      };

    case EFiltersActions.SET_SEARCH_TEXT_REALTORS:
      return {
        ...state,
        searchText: action.payload,
      };

    default:
      return state;
  }
}
